/**
 * GH#1643 — Marketing se abre con pestañas en el orden de GHL. Las que todavía no
 * tienen pantalla quedan deshabilitadas con «Próximamente»: nunca un 404.
 * Se monta desde el ruteo alrededor de las pantallas que ya existen.
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/shared/utils/cn';
import type { RootState } from '@/shared/store/store';
import { pestanasParaRol, itemActivoDe } from '../config/agency-ghl-nav';

export const MarketingTabsGhl: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { pathname } = useLocation();
  // Sólo las pestañas cuya ruta admite el rol: si no, la pestaña manda a /unauthorized.
  const role = useSelector((s: RootState) => s.auth?.user?.role) as string | undefined;
  const pestanas = pestanasParaRol(role);
  const activa = itemActivoDe(pestanas, pathname);
  return (
    <>
      {/* #3296 - a 1440 px «Administrador de anuncios» quedaba fuera de pantalla detrás de un scroll horizontal sin señal
          (medido en prod: barra de 1184 px, contenido 1837). La lista ENVUELVE siempre y no hay scroll.
          #3300 (decisión CTO) - en móvil las «Próximamente» se ocultan (`hidden md:block`): no llevan a ningún lado y envolver
          las 9 ocupaba 308 px de 844. Quedan sólo las activas, así que en móvil van primero sin reordenar nada; en escritorio
          se ven todas en el orden de GHL (GH#1643). Medido en prod a 390: Ads en x 16-220, barra 132 px. */}
      <nav aria-label="Marketing" className="mb-4 border-b border-gray-200 bg-white px-4">
        <ul className="flex flex-wrap gap-1">
          {pestanas.map(p => (
            <li key={p.name} className={p.proximamente || !p.href ? 'hidden md:block' : undefined}>
              {p.proximamente || !p.href ? (
                <span
                  aria-disabled="true"
                  className="inline-flex items-center gap-1.5 px-3 py-2.5 text-sm text-gray-400 cursor-default"
                >
                  {p.name}
                  <span className="rounded-full bg-gray-100 px-1.5 py-0.5 text-[10px] text-gray-500">Próximamente</span>
                </span>
              ) : (
                <Link
                  to={p.href}
                  aria-current={activa === p ? 'page' : undefined}
                  className={cn(
                    'inline-flex px-3 py-2.5 text-sm font-medium border-b-2 -mb-px',
                    activa === p
                      ? 'border-primary-600 text-primary-700'
                      : 'border-transparent text-gray-600 hover:text-gray-900'
                  )}
                >
                  {p.name}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </nav>
      {children}
    </>
  );
};

export default MarketingTabsGhl;
